$(document).on("ready", function()
{
    const oCommande = new Commande({});
    const $body = $("body");

    // $body.on("show.bs.collapse", ".pagesuivicmd__dossier__content", OpenEvent => {
    //    const $target = $(OpenEvent.currentTarget);
    //    const $placeholder = $target.find(".pagesuivicmd__dossier__content_placeholder");
    //    if( $placeholder.length > 0 ) // if theres still the placeholder, need to load the content async
    //    {
    //        sendAjaxRequest({}, {
    //            "f": "xml",
    //            "a": "suivi-commande",
    //            "p": "getDossier.ajax",
    //            "dossier_id": $placeholder.data("dossier-id"),
    //            "done": xml =>
    //            {
    //                  const response = xmlResponse2Json(xml);
    //                  if( response.erreur.code === 0 )
    //                  {
    //                      $placeholder.replaceWith($(response.cdata));
    //                  }
    //            }
    //        })
    //    }
    // });

    $body.on("keyup", "#suivi_commande_v2_search_form__input", KeyUpEvent =>
    {
        const $input = $(KeyUpEvent.currentTarget);
        const $form = $input.parents("form"),
            $button = $form.find("button"),
            $current_results_terms_hidden = $form.find("input:hidden[name='current_result_terms']"),
            current_search_terms = $current_results_terms_hidden.val(),
            terms = $input.val().trim();

        if( terms === "" || current_search_terms !== terms )
        {
            // $button.text("Rechercher");
        }
        else
        {
            // $button.text("Annuler");
        }
    });

    $body.on("click", "#suivicmd_v2_cancel_search", function()
    {
        $(this).css("visibility", "hidden");
        $("#suivi_commande_v2_search_form__input").val("").parents("form").trigger("submit");
        // $("#suivicmd_v2_search_reset").fadeOut(); 
    });

    $body.on("submit", "#suivi_commande_v2_search_form", SubmitEvent =>
    {
        SubmitEvent.preventDefault();

        // useful variables
        const $form = $(SubmitEvent.currentTarget);
        const $input = $form.find("input[type='search']"),
            $button = $form.find("button"),
            $current_results_terms_hidden = $form.find("input:hidden[name='current_result_terms']"),
            $orderfiles_transfer_currentcount_hidden = $form.find("input:hidden[name='orderfiles_transfer_currentcount']"),
            current_search_terms = $current_results_terms_hidden.val(),
            terms = $input.val().trim();


        if( parseInt($orderfiles_transfer_currentcount_hidden.val()) === 0 )
        {
            $button.prop("disabled", true);
            // btn state handling
            if( terms !== "" )
            {
                $input.val("");
                // $button.text("Annuler");
            }
            else
            {
                // $button.text("Rechercher");
            }

            // search handling
            oCommande.searchInSuivi({
                "page": 1,
                "search": terms,
                "expand_all": ( terms.length > 0 ? 1 : 0 ),
                "fail": () => $button.prop("disabled", false),
                "done": xml =>
                {
                    $button.prop("disabled", false);
                    const response = xmlResponse2Json(xml);
                    $current_results_terms_hidden.val(terms);
                    if( response.erreur.code === 0 )
                    {
                        const $container = $("#suivicommande_v2__liste__wrapper");
                        if( $container.length === 1 )
                        {
                            $container.html("");
                            $("#jsSuiviCommandeFirstSeparateur").remove();
                            $container.append($(response.cdata));
                        }
                    }
                }
            });
        }
        else
        {
            const popupDatas = getMessageDatas("message/suivi-commande/transfert-encours");
            erreurJs( popupDatas );
        }
    });
});